import {
    RichTableColumns,
} from 'app/types/richtable.types'

import {
    CQuotesPdf,
} from '../CQuotes.types'

const columns = ({
    l,
}: {
    l: (l:string) => string,
}): RichTableColumns<keyof CQuotesPdf>[] => {
    return [
        {
            id: 'filename',
            headerProps: {
                children: l('Document.documentName'),
            },
            mapCellProps: 'filename',
            sorting: false,
        },
        {
            id: 'createdBy',
            headerProps: {
                children: l('LaneGroup.createdBy'),
            },
            mapCellProps: 'createdBy',
            sorting: false,
        },
        {
            id: 'createdOn',
            headerProps: {
                children: l('Accounts.createdOn'),
            },
            mapCellProps: 'createdOn',
            componentName: 'DateTimeCell',
            sorting: false,
        },
        {
            id: 'attachmentUrl',
            mapCellProps: 'attachmentUrl',
            componentName: 'DownloadDocument',
            width: '50px',
            sorting: false,
        },
    ]
}

export default columns
